<template>
	<el-dialog title="系统提示" :visible.sync="dialogVisible" width="313px" class="warningProp" :close-on-click-modal="false">

		<div class="texts">
			<img src="../../assets/img/monitoring/guolvshezhi/afd.png" alt="" class="imgsize">
			{{tips}}
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name:'WarningProp',
		// props: {
		// 	tips: {
		// 		type: String,
		// 		default: '请勿重复添加,谢谢！'
		// 	}
		// },
		data() {
			return {
				dialogVisible: false,
				tips: '请勿重复添加,谢谢！'
			}
		},
		methods: {
			show(tips){
				this.tips = tips
				this.dialogVisible= true
			}
		}
	}
</script>

<style lang="less">
	.warningProp {
		.el-dialog .el-dialog__body {
			// padding-top: 33px;
			// padding-bottom: 44px;
			padding: 24px 66px;
		}
        .el-dialog .el-dialog__header{
			
			background-color: #f0f3fa!important;
			font-size: 14px;
			.el-dialog__title{
				color: #0092f1!important;
			}
			.el-dialog__headerbtn .el-dialog__close{
				color:#b7c0d3;
			}	
		}

		.texts {
			text-align: center;
			font-family: MicrosoftYaHei;
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 1px;
				color: #999999;
		}

		.addbtn {
			width: 140px;
			height: 40px;
			background-color: #0092f1;
			border-radius: 3px;
			padding: 0px;
			img {
				// width: 18px;
				margin-right: 2px;
			}
			&.el-button{
				padding: 12px 42px;
			}
			&>span{
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				// align-content:space-around;
				justify-content: center;
			}
		}

		.deletbtn {
			width: 140px;
			height: 40px;
			background-color: #fff;
			border-radius: 3px;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			color: #0092f1;
			padding: 0px;
			margin-left: 27px;
			img {
				// width: 18px;
				margin-right: 2px;
			}
			&.el-button{
				padding: 12px 42px;
			}
			&>span{
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				// align-content:space-around;
				justify-content: center;
			}
		}

		.imgsize {
			width: 29px;
			// height: 72px;
		}

	}
</style>

